export const BOTTOM_MENU_BAR_HEIGHT = 64;
